import React from 'react';
import './NavGrouping.css';
import {
  GROUPING_CATEGORY_AREA,
  GROUPING_CATEGORY_EQUIPMENT,
  GROUPING_CATEGORY_TYPE,
  GROUPING_FILTER_AREA_FUNCTIONAL,
  GROUPING_FILTER_AREA_ROOM,
  GROUPING_FILTER_EQUIPMENT_GROUP,
  GROUPING_FILTER_EQUIPMENT_TYPE,
  GROUPING_MODE_GROUP,
  GROUPING_MODE_OFF,
  GROUPING_MODE_SUM
} from '../../constants/actionTypes';
import GroupLink from '../../container/GroupLink';
import { withStyles } from 'material-ui/styles';

const styles = {
  grouping__nav: {
    marginTop: '1rem',
    marginBottom: '1rem'
  }
};

const GroupingNav = ({ classes }) => (
  <div className={classes.grouping__nav}>
    <div className="btn__group">
      <GroupLink mode={GROUPING_MODE_OFF}>Off</GroupLink>
      <GroupLink mode={GROUPING_MODE_GROUP}>Group</GroupLink>
      <GroupLink mode={GROUPING_MODE_SUM}>Sum</GroupLink>
    </div>
    <div className="btn__group">
      <GroupLink category={GROUPING_CATEGORY_EQUIPMENT}>Equipment</GroupLink>
      <GroupLink category={GROUPING_CATEGORY_AREA}>Area</GroupLink>
      <GroupLink category={GROUPING_CATEGORY_TYPE}>Main / CT</GroupLink>
    </div>

    <div className="btn__group">
      <GroupLink filter={GROUPING_FILTER_EQUIPMENT_TYPE}>Type</GroupLink>
      <GroupLink filter={GROUPING_FILTER_EQUIPMENT_GROUP}>Group</GroupLink>
    </div>

    <div className="btn__group">
      <GroupLink filter={GROUPING_FILTER_AREA_FUNCTIONAL}>Functional</GroupLink>
      <GroupLink filter={GROUPING_FILTER_AREA_ROOM}>Room</GroupLink>
    </div>
  </div>
);
export default withStyles(styles, { name: 'GroupingNav' })(GroupingNav);

// <GroupLink filter={GROUPING_FILTER_EQUIPMENT_DESCRIPTION}>Description</GroupLink>
// GROUPING_FILTER_EQUIPMENT_DESCRIPTION,



// WEBPACK FOOTER //
// ./src/components/nav/NavGrouping.js